import React, { useEffect } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import Select from "react-select";
import "./SelectPGAEvent.css";

const GET_EVENTS = graphql`
  query SelectPGAEventQuery {
    eventsForLiveScorecard {
      id
      tournament {
        officialName
      }
    }
  }
`;

const GET_RESEARCH_EVENTS = graphql`
  query SelectPGAEventResearchQuery {
    eventsForPgaResearch {
      id
      tournament {
        officialName
      }
    }
  }
`;

export default function SelectPGAEvent(props) {
  const query = props.loadResearchOptions ? GET_RESEARCH_EVENTS : GET_EVENTS;

  const data = useLazyLoadQuery(query);

  let events;

  if (props.loadResearchOptions) {
    events = data.eventsForPgaResearch;
  } else {
    events = data.eventsForLiveScorecard;
  }

  const firstEvent = events[0];

  let defaultValue = {};

  if (firstEvent) {
    defaultValue = {
      value: firstEvent.id,
      label: firstEvent.tournament.officialName,
    };
  }

  useEffect(() => {
    if (firstEvent) {
      props.setSelectedEventID(firstEvent.id);
    }
  }, []);

  function updateSelectedEvent(selected) {
    props.setSelectedEventID(selected.value);
  }

  return (
    <div className="select-pga-event-container">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>
        Event
        <Select
          id="event"
          className="select-pga-event-select-box"
          options={events.map((event) => {
            return { value: event.id, label: event.tournament.officialName };
          })}
          onChange={updateSelectedEvent}
          defaultValue={defaultValue}
          style={{ zIndex: 100 }}
        />
      </label>
      <br />
    </div>
  );
}
